/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { CitationModule } from '@coursera-web/cds-labs';

import _t from 'i18n!nls/browse-common';

function RoleCitation() {
  return (
    <CitationModule
      citations={_t(`¹ Median salary and job opening data are sourced from Lightcast™ Job Postings Report.
  Content Creator, Machine Learning Engineer and Salesforce Development Representative (1/1/2024 - 12/31/2024)
  All other job roles (7/1/2024 - 7/1/2025)`)}
    />
  );
}

export default RoleCitation;
